import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-catalog-card',
  templateUrl: './catalog-card.component.html',
  styleUrls: ['./catalog-card.component.scss']
})
export class CatalogCardComponent implements OnInit {

  @Input() title;
  @Input() image;
  @Input() selected;
  @Input() backgroundColor;
  @Input() textColor;

  constructor() { }

  ngOnInit() {
  }

}
